const biblia_routes = [
  {
    path: "/biblias",
    name: "biblias",
    component: () => import(/* webpackChunkName: "biblia" */ "../pages/BibliaPage.vue"),
  },
  {
    path: "/biblias/nuevo",
    name: "biblias.registros.nuevo",
    component: () => import(/* webpackChunkName: "biblia.registros" */ "../pages/BibliaRegistrosPage.vue"),
  },
  {
    path: "/biblias/:id/registros",
    name: "biblias.registros",
    component: () => import(/* webpackChunkName: "biblia.registros" */ "../pages/BibliaRegistrosPage.vue"),
  },
];

export default biblia_routes;
